var heading_default = {
  "fontElementMap": "nYyY4",
  "elementSpacing": "DT2ro",
  "headerOne": "_3xCHL DT2ro",
  "headerTwo": "T-JYI DT2ro",
  "headerThree": "_0nFb2 DT2ro",
  "headerFour": "fbygX DT2ro",
  "headerFive": "KuFPP DT2ro",
  "headerSix": "NOUDI DT2ro",
  "child": "dWU7-"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
